import { isNil } from 'lodash';
import { MBEmptyListPlaceholder } from '@shared/components/list';
import { MBLoadingIndicator } from '@shared/components/loading';
import { useChannel } from '@shared/util/hooks';
import { i18n } from '@shared/util/i18n';
import { CreateCardEntityForm } from './CreateCardEntityForm';
import { ReadOnlyCardEntityForm } from './ReadOnlyCardEntityForm';

interface ExternalContentProps {
  cardId?: string | null;
  channelId: number;
  templateSlug?: string;
}

export function ExternalContent({ cardId, channelId, templateSlug }: ExternalContentProps) {
  const channel = useChannel({ channelId });
  if (isNil(channel)) {
    return <MBLoadingIndicator fill center />;
  }

  if (!isNil(cardId)) {
    return <ExternalCard channelId={channelId} cardId={cardId} templateSlug={templateSlug} />;
  } else {
    return <ExternalForm channelId={channelId} templateSlug={templateSlug} />;
  }
}

interface ExternalCardProps extends Omit<ExternalContentProps, 'cardId'> {
  cardId: string;
}

function ExternalCard({ cardId, channelId, templateSlug }: ExternalCardProps) {
  const channel = useChannel({ channelId });
  const workflowTemplateId = channel?.workflowTemplateId;

  if (isNil(workflowTemplateId) || isNil(templateSlug)) {
    return <MBEmptyListPlaceholder title={i18n('externalForm.noTemplateFound')} />;
  }

  return (
    <ReadOnlyCardEntityForm channelId={channelId} templateSlug={templateSlug} entityId={cardId} />
  );
}

type ExternalFormProps = Omit<ExternalContentProps, 'cardId'>;

function ExternalForm({ channelId, templateSlug }: ExternalFormProps) {
  const channel = useChannel({ channelId });
  const workflowTemplateId = channel?.workflowTemplateId;

  if (isNil(workflowTemplateId) || isNil(templateSlug)) {
    return <MBEmptyListPlaceholder title={i18n('externalForm.noTemplateFound')} />;
  }

  return <CreateCardEntityForm channelId={channelId} templateSlug={templateSlug} />;
}
